import React, { useState, useEffect } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';

export default function BreadcrumbLink(props) {
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const combinedObject = {
      LTRole: localStorage.getItem("LTRole"),
      CDRole: localStorage.getItem("CDRole"),
    };
    const links = props?.labelList?.map((item, index) =>
      item.path ?
        <Link underline="always" key={index} style={{ cursor: 'pointer', color: '#e70d0dff' }} onClick={() => navigate(item.path, { state:{ combinedObject }})}>
          {item.title}
        </Link> :
        <Typography key={index} style={{ color: '#e70d0dff' }}>
          {item.title}
        </Typography>
    );
    setBreadcrumbs(links)
  }, [navigate, props?.labelList])

  return (
    <Stack spacing={2} className={`${props.className}`}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className={`${props.className}-breadcrumb`}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}